/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import { currentUser } from '../../utils/Auth/auth';
import Select from 'react-select';
import { useMemo } from 'react';

const AgentAddingWindow = ({
  data,
  setData = () => {},
  extension,
  // eslint-disable-next-line no-unused-vars
  setExtension = () => {},
  enableExtension = false,
}) => {
  const activityStatuses = [
    { label: <span>Active</span>, value: 'A' },
    { label: 'Inactive', value: 'N' },
  ];

  const activityStatusesBool = [
    { label: <span>Active</span>, value: true },
    { label: 'Inactive', value: false },
  ];

  const countries = [
    { label: 'Canada', value: 'CAN' },
    { label: 'USA', value: 'USA' },
  ];
  const branches = [
    {
      label: 'Toronto, ON, Canada',
      value: '1',
      disabled:
        !currentUser.branches.includes('1') &&
        !currentUser.baseBranch.includes('1'),
    },
    {
      label: 'Port Reading, NJ, USA',
      value: '2',
      disabled:
        !currentUser.branches.includes('2') &&
        !currentUser.baseBranch.includes('2'),
    },
    {
      label: 'Meest California, USA',
      value: '3',
      disabled:
        !currentUser.branches.includes('3') &&
        !currentUser.baseBranch.includes('3'),
    },
    {
      label: 'Chicago, IL, USA',
      value: '4',
      disabled:
        !currentUser.branches.includes('4') &&
        !currentUser.baseBranch.includes('4'),
    },
  ];

  const setField = (field, value) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };

  const dayOptions = [
    { value: 'Mo', label: 'Monday' },
    { value: 'Tu', label: 'Tuesday' },
    { value: 'We', label: 'Wednesday' },
    { value: 'Th', label: 'Thursday' },
    { value: 'Fr', label: 'Friday' },
    { value: 'Sa', label: 'Saturday' },
    { value: 'Su', label: 'Sunday' },
  ];

  return (
    <div className="min-w-[95vw] min-h-[80vh]">
      <div className="overflow-y-auto max-h-[75vh] p-4">
        <div className="flex flex-wrap justify-center">
          <div className="w-full my-4 font-semibold">Main info</div>
          {/* Status */}
          <div className="flex flex-col m-3">
            <span>Status</span>
            <select
              type="text"
              name="status"
              onChange={(e) => setField('status', e.target.value)}
              value={
                activityStatuses.some((item) => item.value === data?.status)
                  ? data?.status
                  : '' || ''
              }
              placeholder="Status..."
              className={classNames(
                'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
                !activityStatuses.some((item) => item.value === data?.status) &&
                  'text-gray-400',
              )}
            >
              <option className="text-gray-400" value="" disabled>
                Select a status...
              </option>
              {activityStatuses.map((item) => (
                <option
                  className="text-gray-600"
                  value={item.value}
                  key={item.value}
                >
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Agent Code */}
          <div className="flex flex-col m-3">
            <span>Agent Code</span>
            <input
              type="text"
              name="agentCode"
              onChange={(e) => setField('agentCode', e.target.value)}
              value={data?.agentCode}
              placeholder="Agent Code..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Branch Id */}
          <div className="flex flex-col m-3">
            <span>Branch</span>
            <select
              type="text"
              name="branch"
              onChange={(e) =>
                setField('branchId', Number.parseInt(e.target.value))
              }
              value={
                branches.some(
                  (item) => item.value === data?.branchId.toString(),
                )
                  ? data?.branchId.toString()
                  : '' || ''
              }
              placeholder="Branch..."
              className={classNames(
                'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
                !branches.some(
                  (item) => item.value === data?.branchId.toString(),
                ) && 'text-gray-400',
              )}
            >
              <option className="text-gray-400" value="" disabled>
                Select a branch...
              </option>
              {branches.map((item) => (
                <option
                  className={classNames(
                    !item?.disabled ? 'text-gray-600' : 'text-gray-300',
                  )}
                  value={item.value.toString()}
                  key={item.value}
                  disabled={item?.disabled}
                >
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Agent Name */}
          <div className="flex flex-col m-3">
            <span>Agent Name</span>
            <input
              type="text"
              name="agentName"
              onChange={(e) => setField('agentName', e.target.value)}
              value={data?.agentName}
              placeholder="Agent Name..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Currency */}
          <div className="flex flex-col m-3">
            <span>Currency</span>
            <input
              type="text"
              name="currency"
              onChange={(e) => setField('currency', e.target.value)}
              value={data?.currency}
              placeholder="Currency..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Service List */}
          <div className="flex flex-col m-3">
            <span>Service List</span>
            <input
              type="text"
              name="servList"
              onChange={(e) => setField('servList', e.target.value)}
              value={data?.servList}
              placeholder="Service List..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Languages */}
          <div className="flex flex-col m-3">
            <span>Languages</span>
            <input
              type="text"
              name="language"
              onChange={(e) => setField('language', e.target.value)}
              value={data?.language}
              placeholder="Languages..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Work Hours */}
          <div className="w-full justify-center my-5">
            <div>Work Hours</div>
            <input
              type="text"
              name="workHours"
              onChange={(e) => setField('workHours', e.target.value)}
              value={data?.workHours}
              placeholder="Work Hours..."
              className="p-2 border-b-2 border-gray-300 focus:outline-none mx-2 focus:border-blue-300 w-2/3 text-center min-w-48"
            />
          </div>

          <div className="w-full my-4 font-semibold">Location</div>

          {/* Address */}
          <div className="flex flex-col m-3">
            <span>Address</span>
            <input
              type="text"
              name="address"
              onChange={(e) => setField('address', e.target.value)}
              value={data?.address}
              placeholder="Address..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Unit */}
          <div className="flex flex-col m-3">
            <span>Unit</span>
            <input
              type="text"
              name="unit"
              onChange={(e) => setField('unit', e.target.value)}
              value={data?.unit}
              placeholder="Unit..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Province */}
          <div className="flex flex-col m-3">
            <span>State/Province</span>
            <input
              type="text"
              name="provinceState"
              onChange={(e) => setField('provinceState', e.target.value)}
              value={data?.provinceState}
              placeholder="Province/State..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* City */}
          <div className="flex flex-col m-3">
            <span>City</span>
            <input
              type="text"
              name="city"
              onChange={(e) => setField('city', e.target.value)}
              value={data?.city}
              placeholder="City..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Country */}
          <div className="flex flex-col m-3">
            <span>Country</span>
            <select
              type="text"
              name="country"
              onChange={(e) => setField('country', e.target.value)}
              value={
                countries.some(
                  (item) => item.value === data?.country.toString(),
                )
                  ? data?.country?.toString()
                  : '' || ''
              }
              placeholder="Country..."
              className={classNames(
                'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
                !countries.some(
                  (item) => item.value === data?.country.toString(),
                ) && 'text-gray-400',
              )}
            >
              <option className="text-gray-400" value="" disabled>
                Select a country...
              </option>
              {countries.map((item) => (
                <option
                  className="text-gray-600"
                  value={item.value}
                  key={item.value}
                >
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Postal Code */}
          <div className="flex flex-col m-3">
            <span>Postal Code</span>
            <input
              type="text"
              name="pCodeZip"
              onChange={(e) => setField('pCodeZip', e.target.value)}
              value={data?.pCodeZip}
              placeholder="Postal Code..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Latitude */}
          <div className="flex flex-col m-3">
            <span>Latitude</span>
            <input
              type="text"
              name="latitude"
              onChange={(e) => setField('latitude', e.target.value)}
              value={data?.latitude}
              placeholder="Latitude..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Longitude */}
          <div className="flex flex-col m-3">
            <span>Longitude</span>
            <input
              type="text"
              name="longitude"
              onChange={(e) => setField('longitude', e.target.value)}
              value={data?.longitude}
              placeholder="Longitude..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          <div className="w-full my-4 font-semibold">Contact info</div>

          {/* Contact Name */}
          <div className="flex flex-col m-3">
            <span>Contact Name</span>
            <input
              type="text"
              name="contactName"
              onChange={(e) => setField('contactName', e.target.value)}
              value={data?.contactName}
              placeholder="Contact Name..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Phone */}
          <div className="flex flex-col m-3">
            <span>Phone</span>
            <input
              type="text"
              name="phone1"
              onChange={(e) => setField('phone1', e.target.value)}
              value={data?.phone1}
              placeholder="Phone..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Phone 2 */}
          <div className="flex flex-col m-3">
            <span>Phone 2</span>
            <input
              type="text"
              name="phone2"
              onChange={(e) => setField('phone2', e.target.value)}
              value={data?.phone2}
              placeholder="Phone 2..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Email */}
          <div className="flex flex-col m-3">
            <span>Email</span>
            <input
              type="text"
              name="email"
              onChange={(e) => setField('email', e.target.value)}
              value={data?.email}
              placeholder="Email..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Fax */}
          <div className="flex flex-col m-3">
            <span>Fax</span>
            <input
              type="text"
              name="fax"
              onChange={(e) => setField('fax', e.target.value)}
              value={data?.fax}
              placeholder="Fax..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* SelPhone */}
          <div className="flex flex-col m-3">
            <span>Cellphone</span>
            <input
              type="text"
              name="selPhone"
              onChange={(e) => setField('selPhone', e.target.value)}
              value={data?.selPhone}
              placeholder="Cellphone..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Free Phone */}
          <div className="flex flex-col m-3">
            <span>Free Phone</span>
            <input
              type="text"
              name="freePhone"
              onChange={(e) => setField('freePhone', e.target.value)}
              value={data?.freePhone}
              placeholder="Free Phone..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Website */}
          <div className="flex flex-col m-3">
            <span>Website</span>
            <input
              type="text"
              name="website"
              onChange={(e) => setField('website', e.target.value)}
              value={data?.website}
              placeholder="Website..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          <div className="w-full my-4 font-semibold">Other</div>

          {/* Salutation */}
          <div className="flex flex-col m-3">
            <span>Salutation</span>
            <input
              type="text"
              name="salutation"
              onChange={(e) => setField('salutation', e.target.value)}
              value={data?.salutation}
              placeholder="Salutation..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* WebSearch */}
          <div className="flex flex-col m-3">
            <span>Web Search</span>
            <input
              type="text"
              name="webSearch"
              onChange={(e) => setField('webSearch', e.target.value)}
              value={data?.webSearch}
              placeholder="Web Search..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Catalog */}
          <div className="flex flex-col m-3">
            <span>Catalog</span>
            <input
              type="text"
              name="catalog"
              onChange={(e) => setField('catalog', e.target.value)}
              value={data?.catalog}
              placeholder="Catalog..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Mega Police */}
          <div className="flex flex-col m-3">
            <span>Megapolis</span>
            <input
              type="text"
              name="megaPolice"
              onChange={(e) => setField('megaPolice', e.target.value)}
              value={data?.megaPolice}
              placeholder="Megapolis..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Rank */}
          <div className="flex flex-col m-3">
            <span>Rank</span>
            <input
              type="text"
              name="rank"
              onChange={(e) => setField('rank', e.target.value)}
              value={data?.rank}
              placeholder="Rank..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Business Status */}
          <div className="flex flex-col m-3">
            <span>Business Status</span>
            <input
              type="text"
              name="busStatus"
              onChange={(e) => setField('busStatus', e.target.value)}
              value={data?.busStatus}
              placeholder="Business Status..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Pickup */}
          <div className="flex flex-col m-3">
            <span>Pickup</span>
            <input
              type="text"
              name="pickup"
              onChange={(e) => setField('pickup', e.target.value)}
              value={data?.pickup}
              placeholder="Pickup..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Use Carrier */}
          <div className="flex flex-col m-3">
            <span>Use Carrier</span>
            <select
              type="text"
              name="status"
              onChange={(e) => setField('useCarrier', e.target.value === 'A')}
              value={data?.useCarrier ? 'A' : 'N'}
              placeholder="Use Carrier..."
              className={classNames(
                'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
                !activityStatuses.some((item) => item.value === data?.status) &&
                  'text-gray-400',
              )}
            >
              <option className="text-gray-400" value="" disabled>
                Select a status...
              </option>
              {activityStatuses.map((item) => (
                <option
                  className="text-gray-600"
                  value={item.value}
                  key={item.value}
                >
                  {item.label}
                </option>
              ))}
            </select>
            {/* <input
              type="text"
              name="useCarrier"
              onChange={(e) => setField('useCarrier', e.target.value)}
              value={data?.useCarrier}
              placeholder="Use Carrier..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            /> */}
          </div>

          {/* Master */}
          <div className="flex flex-col m-3">
            <span>Master</span>
            <input
              type="text"
              name="master"
              onChange={(e) => setField('master', e.target.value)}
              value={data?.master}
              placeholder="Master..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Carrier Code */}
          <div className="flex flex-col m-3">
            <span>Carrier Code</span>
            <input
              type="text"
              name="carrierCode"
              onChange={(e) => setField('carrierCode', e.target.value)}
              value={data?.carrierCode}
              placeholder="Carrier Code..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Zones */}
          <div className="flex flex-col m-3">
            <span>Zones</span>
            <input
              type="text"
              name="zones"
              onChange={(e) => setField('zones', e.target.value)}
              value={data?.zones}
              placeholder="Zones..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Agent Group */}
          <div className="flex flex-col m-3">
            <span>Agent Group</span>
            <input
              type="text"
              name="agentGroup"
              onChange={(e) => setField('agentGroup', e.target.value)}
              value={data?.agentGroup}
              placeholder="Agent Group..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Suspension */}
          <div className="flex flex-col m-3">
            <span>Suspension</span>
            <input
              type="text"
              name="suspension"
              onChange={(e) => setField('suspension', e.target.value)}
              value={data?.suspension}
              placeholder="Suspension..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* To Be Printed */}
          <div className="flex flex-col m-3">
            <span>To Be Printed</span>
            <input
              type="text"
              name="toBePrinted"
              onChange={(e) => setField('toBePrinted', e.target.value)}
              value={data?.toBePrinted}
              placeholder="To Be Printed..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Additional Name */}
          <div className="flex flex-col m-3">
            <span>Additional Name</span>
            <input
              type="text"
              name="additionalName"
              onChange={(e) => setField('additionalName', e.target.value)}
              value={data?.additionalName}
              placeholder="Additional Name..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>

          {/* Wholeseller Code */}
          <div className="flex flex-col m-3">
            <span>Wholeseller Code</span>
            <input
              type="text"
              name="wholesellerCode"
              onChange={(e) => setField('wholesellerCode', e.target.value)}
              value={data?.wholesellerCode}
              placeholder="Wholeseller Code..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>
          {enableExtension && (
            <>
              <div className="w-full my-4 font-semibold">Extension</div>

              {/* Extension (ADDITIONAL) */}
              <div className="flex flex-col m-3">
                <span>Pickup Report</span>
                <select
                  type="text"
                  name="pickRep"
                  onChange={(e) =>
                    setExtension({
                      ...extension,
                      pickRep: e.target.value === 'true',
                    })
                  }
                  value={!extension ? '' : extension?.pickRep}
                  placeholder="Pickup Report..."
                  className={classNames(
                    'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
                  )}
                >
                  <option className="text-gray-400" value="" disabled>
                    Select a status...
                  </option>
                  {activityStatusesBool.map((item) => (
                    <option
                      className="text-gray-600"
                      value={item.value}
                      key={item.value}
                    >
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* Driver Id */}
              <div className="flex flex-col m-3">
                <span>Driver name</span>
                <input
                  type="text"
                  name="driverId"
                  onChange={(e) =>
                    setExtension((prevData) => ({
                      ...prevData,
                      driverId: e.target.value !== '' ? e.target.value : null,
                    }))
                  }
                  value={extension?.driverId}
                  placeholder="Driver Id..."
                  className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
                />
              </div>
              {/* Pick up days */}
              {/* <div className="flex flex-col m-3">
                <span>Pick up days</span>
                <input
                  type="text"
                  name="pickUpDays"
                  onChange={(e) =>
                    setExtension((prevData) => ({
                      ...prevData,
                      pickUpDays: e.target.value !== '' ? e.target.value : null,
                    }))
                  }
                  value={extension?.pickUpDays}
                  placeholder="Pick up days..."
                  className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
                />
              </div> */}
              <div className="flex flex-col m-3">
                <span>Pick up days</span>
                <Select
                  isMulti
                  name="pickUpDays"
                  options={dayOptions}
                  value={useMemo(() => {
                    if (!extension?.pickUpDays) return [];
                    return extension?.pickUpDays.split(',').map((day) => ({
                      value: day,
                      label:
                        dayOptions.find((option) => option.value === day)
                          ?.label || day,
                    }));
                  }, [extension?.pickUpDays])}
                  onChange={(selectedOptions) => {
                    const newValue =
                      selectedOptions.length > 0
                        ? selectedOptions
                            .map((option) => option.value)
                            .join(',')
                        : null;
                    setExtension((prevData) => ({
                      ...prevData,
                      pickUpDays: newValue,
                    }));
                  }}
                  placeholder="Select pick up days..."
                  className="w-54 mx-2"
                  classNamePrefix="select"
                  menuPortalTarget={document.body} // Render menu in document.body
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: 'none',
                      borderRadius: 0,
                      padding: 0.6,
                      margin: '0',
                      borderBottom: '2px solid #D1D5DB', // gray-300
                      boxShadow: 'none',
                      backgroundColor: 'transparent',
                      '&:hover': {
                        borderBottom: '2px solid #93C5FD', // blue-300
                      },
                    }),
                    input: (base) => ({
                      ...base,
                      color: '#1F2937', // gray-800
                      padding: '0',
                      margin: '0',
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#9CA3AF', // gray-400
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#BFDBFE', // blue-200
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#1E40AF', // blue-800
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#1E40AF', // blue-800
                      '&:hover': {
                        backgroundColor: '#93C5FD', // blue-300
                        color: '#1E3A8A', // blue-900
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: '#FFFFFF', // white
                      borderRadius: '0.25rem',
                      marginTop: '0.25rem',
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      maxHeight: '0.25rem',
                      height: '0.25rem',
                      zIndex: 9999, // Ensure menu appears above other elements
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      backgroundColor: isSelected
                        ? '#DBEAFE' // blue-100
                        : isFocused
                          ? '#EFF6FF' // blue-50
                          : '#FFFFFF', // white
                      color: '#1F2937', // gray-800
                      padding: '0.5rem 1rem',
                      '&:active': {
                        backgroundColor: '#DBEAFE', // blue-100
                      },
                    }),
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentAddingWindow;
